<template>
    <div>
        <LeaseholdNotes classes="is-6-tablet is-3-desktop" />
    </div>
</template>

<script>
import LeaseholdNotes from '../components/LeaseholdNotes.vue';

export default {
    components: {
        LeaseholdNotes,
    },
};
</script>
